import React, { createContext, useContext, useState, ReactNode } from 'react';
import axios from 'axios';

interface Statistic {
    company_count: number;
    job_count: number;
    candidate_count: number;
    match_count: number;
}

interface StatisticContextProps {
    statistic: Statistic | null;
    setStatistic: (stats: Statistic | null) => void;
    refreshStatistic: () => Promise<void>;
}

const StatisticContext = createContext<StatisticContextProps | undefined>(undefined);

export const useStatistic = (): StatisticContextProps => {
    const context = useContext(StatisticContext);
    if (!context) {
        throw new Error('useStatistic must be used within a StatisticProvider');
    }
    return context;
};

interface StatisticProviderProps {
    children: ReactNode;
}

export const StatisticProvider = ({ children }: StatisticProviderProps) => {
    const [statistic, setStatistic] = useState<Statistic | null>(null);
    const API_URL = import.meta.env.VITE_APP_API_URL;
    const API_STATISTICS = `${API_URL}/statistic`;

    const refreshStatistic = async () => {
        try {
            const response = await axios.get<Statistic>(API_STATISTICS, {
                headers: { Accept: 'application/json' },
            });
            setStatistic(response.data);
        } catch (error) {
            console.error('Failed to refresh statistics data:', error);
            // Optionally handle error, e.g., setStatistic(null)
        }
    };

    return (
        <StatisticContext.Provider value={{ statistic, setStatistic, refreshStatistic }}>
            {children}
        </StatisticContext.Provider>
    );
};
